export const STORE_KEY = 'storeId';
export const STORE_KEY_IN_QUERY = 'store';
export const STORE_COOKIE = 'storeId';
export enum storeCookieMaxAge {
  REMEMBER = 31536000000,
  DO_NOT_REMEMBER = 1800000,
}
